import { Collapse, List } from "@mui/material";
import type { Site } from "../../../types/Site";
import { SiteItem } from "./site-item";

interface SiteDropdownProps {
    isOpen: boolean;
    allowedSites: Site[];
    setSelectedSite: (site: Site) => void;
}

/**
 * SiteDropdown
 *
 * Renders a collapsible dropdown list of allowed sites using the SiteItem component.
 * Controlled by the `isOpen` prop. Receives allowedSites and setSelectedSite as props.
 *
 * @param {object} props
 * @param {boolean} props.isOpen - Whether the dropdown is open/visible
 * @param {Site[]} props.allowedSites - List of sites to display
 * @param {function} props.setSelectedSite - Function to set the selected site
 */
export const SiteDropdown = ({
    isOpen,
    allowedSites,
    setSelectedSite,
}: SiteDropdownProps) => {
    return (
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div">
                {allowedSites.map((site) => (
                    <SiteItem
                        key={site.id}
                        site={site}
                        setSelectedSite={setSelectedSite}
                    />
                ))}
            </List>
        </Collapse>
    );
};
